function tryIncreaseDepth(dragItem) {
  var _this$props = this.props,
      maxDepth = _this$props.maxDepth,
      childrenProp = _this$props.childrenProp,
      collapsed = _this$props.collapsed;
  var pathFrom = this.getPathById(dragItem.id);
  var itemIndex = pathFrom[pathFrom.length - 1];
  var newDepth = pathFrom.length + this.getItemDepth(dragItem); // has previous sibling and isn't at max depth

  if (itemIndex > 0 && newDepth <= maxDepth) {
    var prevSibling = this.getItemByPath(pathFrom.slice(0, -1).concat(itemIndex - 1)); // previous sibling is not collapsed

    if (!prevSibling[childrenProp].length || !this.isCollapsed(prevSibling)) {
      var pathTo = pathFrom.slice(0, -1).concat(itemIndex - 1).concat(prevSibling[childrenProp].length); // if collapsed by default
      // and was no children here
      // open this node

      var collapseProps = {};

      if (collapsed && !prevSibling[childrenProp].length) {
        collapseProps = this.onToggleCollapse(prevSibling, true);
      }

      this.moveItem({
        dragItem: dragItem,
        pathFrom: pathFrom,
        pathTo: pathTo
      }, collapseProps);
    }
  }
}

export { tryIncreaseDepth };
//# sourceMappingURL=tryIncreaseDepth.js.map
